import(/* webpackMode: "eager" */ "/root/options-saas/app/global-error.tsx");
